import React, { ReactNode } from "react";

import s from "./TableRowCell.module.scss";

interface IProps {
	children: JSX.Element | JSX.Element[] | ReactNode | string | number;
	cellStyle?: React.CSSProperties
}

export const TableRowCell = ({ children, cellStyle }: IProps): JSX.Element => (
	<div className={s.rCell}>
		<div className={s.rCell__row}>
			<div className={s.rCell__item} style={cellStyle}>
				{children}
			</div>
		</div>
	</div>
);
